import {mapGetters} from 'vuex';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
export default {
    name: 'mvtRating',
    inject: ['$eventBus'],
    emits: ['update:modelValue'],
    components: {
        mvtRadio
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        _value: {
            get(){
                return this.modelValue;
            },
            set(value){
                this.$emit('update:modelValue', value);
            }
        }
    },
    data(){
        return {
            data: [
                {
                    text: 'Would definitely recommend',
                    value: 5
                },
                {
                    text: 'Likely to recommend',
                    value: 4
                },
                {
                    text: 'Average',
                    value: 3
                },
                {
                    text: 'Unlikely to recommend',
                    value: 2
                },
                {
                    text: 'Would not recommend',
                    value: 1
                }
            ]
        }
    },
    props: {
        modelValue: {
            type: Number,
            default: 0
        }
    }
};
